import storage from 'src/util/storage';

export function INIT(state) {
	state.init = true;
}

export function RESET(state) {
	Object.entries(state).forEach(([key]) => {
		state[key] = null;
		storage.remove(`auth.${key}`);
	});
}

export function SET_ACCESS_TOKEN(state, accessToken) {
	state.accessToken = accessToken;
	storage.set('auth.accessToken', accessToken);
}

export function SET_CURRENT_USER(state, user) {
	state.currentUser = {
		ID: user.ID,
		email: user.email,
		isAdmin: user.isAdmin,
		lock: user.lock,
		firstName: user.firstName,
		lastName: user.lastName,
		streetAddress: user.streetAddress,
		zipCode: user.zipCode,
		city: user.city,
		latitude: user.latitude,
		longitude: user.longitude,
		phoneNumber: user.phoneNumber,
		website: user.website,
		privacyUrl: user.privacyUrl,
		imprintUrl: user.imprintUrl,
		company: user.company,
		contactEmail: user.contactEmail,
		contactEmail2: user.contactEmail2,
		invoiceEmail: user.invoiceEmail,
		billingAddress: user.billingAddress,
		subscriptionStatus: user.subscriptionStatus,
		fbPageId: user.fbPageId,
		communicationChannel: user.communicationChannel,
		product: user.product,
	};
	storage.set('auth.currentUser', state.currentUser);
}

export function UPDATE_CURRENT_USER(state, user) {
	Object.assign(state.currentUser, user);
	storage.set('auth.currentUser', state.currentUser);
}

export function UPDATE_CURRENT_USER_BILLING_ADDRESS(state, billingAddress) {
	Object.assign(state.currentUser.billingAddress, billingAddress);
	storage.set('auth.currentUser', state.currentUser);
}
